import {font_s_md, font_s_sm, colors} from '@xpertdox_js/xdstyle';

export default {
  container: {
    background: colors.offWhite,
    height: '95%',
    overflowY: 'scroll',
    fontSize: '1.2rem',
    padding: '12px 8px'
  },
  itemTitle: {
    ...font_s_md,
    margin: '0 0 4px',
  },
  itemValue: {
    ...font_s_sm,
    margin: '0 0 20px',
  }
}
